<template>
    <div v-bind:style="{float: direction}">
        <!-- <el-button type="warning" @click="openSendPost" v-if="showApplyPost == '0'"><i class="el-icon-edit"></i> 发布帖子</el-button> -->
        <el-dialog
            title="发布帖子"
            :visible.sync="dialogPostVisible"
            width="50%"
            @opened="openDialog"
            :before-close="handleClose">
            <el-row type="flex">
                <el-col :span="10">
                    <el-input
                        placeholder="请输入帖子标题"
                        v-model="postTitle"
                        clearable>
                    </el-input>
                </el-col>
                <el-col :span="10" :offset="1">
                    <el-select v-model="postCategory" clearable placeholder="请选择分类" @change="selectPost">
                        <el-option
                        v-for="item in categoryOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <div id="wangEditorSection"></div>
                </el-col>
            </el-row>
            <el-row type="flex" justify="end">
                <el-col :span="3">
                    <el-button @click="cancelPost">取 消</el-button>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" @click="sendPost">发 帖</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SendPost',
    props:{
        direction: String,
        showApplyPost: String
    },
    data() {
        return {
            serveHost: process.env.VUE_APP_URL,
            dialogPostVisible: false,
            postTitle:'',
            postCategory:'',
            categoryOptions:[],
            we:{},
            categoryName:'',
            firstShowEditor:0,
        }
    },
    methods:{
        selectPost:function(event) {
            var _vm = this;
            this.categoryOptions.forEach((item, index) => {
                if(item.value == event) {
                    _vm.categoryName = item.label;
                }
            });
        },
        openSendPost() {
            this.user = localStorage.getItem('user') == null? {} : JSON.parse(localStorage.getItem('user'));
            if(this.user.userid) {
                if(this.user.postAuth == 1) {
                    this.$message({
                        type:'warning',
                        message:'暂无发帖权限'
                    });
                } else {
                    this.dialogPostVisible = true;
                }
            } else {
                this.$message({
                    type:'warning',
                    message:'请先登录后再试'
                });
            }
        },
        openDialog() {
            if(this.firstShowEditor == 0) {
                let E = window.wangEditor;
                let editor = new E('#wangEditorSection');
                editor.customConfig.menus = [
                    'head',  // 标题
                    'bold',  // 粗体
                    'fontSize',  // 字号
                    'fontName',  // 字体
                    'italic',  // 斜体
                    'underline',  // 下划线
                    'strikeThrough',  // 删除线
                    'foreColor',  // 文字颜色
                    'backColor',  // 背景颜色
                    // 'link',  // 插入链接
                    'list',  // 列表
                    'justify',  // 对齐方式
                    'quote',  // 引用
                    // 'emoticon',  // 表情
                    // 'image',  // 插入图片
                    // 'table',  // 表格
                    // 'video',  // 插入视频
                    // 'code',  // 插入代码
                    'undo',  // 撤销
                    'redo'  // 重复
                ];
                editor.create();
                this.we = editor;
            }
            this.firstShowEditor = 1;
            
        },
        handleClose(done) {
            this.clearPostContent();
        },
        sendPost() {
            this.$confirm('确认发帖吗？')
            .then(_ => {
                // console.log(this.postTitle);
                // console.log(this.we.txt.html());
                var _vm = this;
                $.ajax({
                    type:'GET',
                    url: _vm.serveHost + "/api/v1/post/main/post/category/add",
                    data:{
                        category: _vm.postCategory,
                        userId: _vm.user.userid,
                        content: _vm.we.txt.html(),
                        title: _vm.postTitle,
                        categoryName: _vm.categoryName
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        // if(r.code != "2000000") {
                        //     console.error('get add post error.');
                        // }
                        if(r.code === '2008001') {
                            _vm.dialogPostVisible = false;
                            _vm.clearPostContent();
                            _vm.$message({
                                type: 'success',
                                message: r.msg
                            });
                        } else {
                            _vm.dialogPostVisible = false;
                            _vm.clearPostContent();
                            _vm.$message({
                                type: 'error',
                                message: r.msg
                            });
                        }
                    }
                });
                done();
            })
            .catch(_ => {});
        },
        cancelPost() {
            this.$confirm('确认关闭？')
            .then(_ => {
                this.clearPostContent();
                done();
            })
            .catch(_ => {});
        },
        clearPostContent() {
            this.dialogPostVisible = false;
            this.postTitle = '';
            this.postCategory = '';
            this.we.txt.clear();
        }
    },
    created() {
        var _vm = this;
        // 帖子类别
        $.get(_vm.serveHost + "/api/v1/home/post/category", function(r){
            if(r.code != "2000000") {
                console.error('get categoryOptions error.');
                return;
            } 
            _vm.categoryOptions = r.data;
        });
    }
}
</script>